export const messages = {
    "shared-link.footer.link.install": "Dùng thử miễn phí {brandName}",
    "shared-link.footer.link.mobile": "{brandName} cho thiết bị di động",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Dữ liệu được bảo vệ",
    "shared-link.password-dialog-box.message": "Vui lòng cho biết mật khẩu để truy cập dữ liệu được chia sẻ",
    "shared-link.password-dialog-box.hint.password": "Mật khẩu",
    "shared-link.password-dialog-box.message.invalid-password": "Mật khẩu không chính xác",
    "shared-link.form.button.open": "Mở",
    "shared-link.page-not-found.title": "Không tìm thấy trang",
    "shared-link.page-not-found.message.main": "Không tìm thấy trang bạn đang tìm kiếm.",
    "shared-link.page-not-found.message.description": "Có thể liên kết đã lỗi thời hoặc bạn đã nhập sai địa chỉ.",
    "shared-link.page-not-found.message.error": "Mã lỗi: 404",
    "shared-link.restore-file.label.size": "Kích thước",
    "shared-link.restore-file.button.restore": "Tải xuống",
    "shared-link.links-table.column.name": "Tên",
    "shared-link.links-table.column.size": "Kích cỡ",
    "shared-link.links-table.action.restore": "Tải xuống",
    "shared-link.links-table.action.restore-all": "Tải xuống tất cả",
    "shared-link.side-bar.selected.title:plural": "Đã chọn {count} mục | Đã chọn {count} mục",
    "shared-link.links-table.label.size": "Kích cỡ",
    "shared-link.links-table.message.empty-folder": "Thư mục này trống"
};
